import { keepPreviousData, useQuery } from "@tanstack/react-query";
import axiosInstance from "axiosConfig";

interface GetAdminSuccessorsHookType {
  uuid?: string;
}

export function useGetAdminSuccessors({
  uuid,
}: GetAdminSuccessorsHookType) {
  return useQuery({
    queryKey: ["admin", "successors", uuid],
    queryFn: async () => {
      return axiosInstance.get(`/admin/successors/${uuid}`).then((res) => res.data);
    },
    placeholderData: keepPreviousData,
    select: ({ data }) => data,
    retry: false,
    enabled: !!uuid,
    staleTime: 1000 * 15,
  });
}
